import * as React from 'react';
import { cn } from '@companion-professional/webutils';

export const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('p-5 md:p-6', className)} {...props} />
);
CardContent.displayName = 'CardContent';
